import { doc, DocumentReference } from 'firebase/firestore';
import { docData } from 'rxfire/firestore';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { IUser } from '../../../types';
import { IReportOption, reportOptions } from '../../reports/reportOptions';
import { authenticatedUserProvider } from '../../userProvider';

export interface IReportSettings {
  report: IReportOption;
}

const defaultSettings: IReportSettings = {
  report: reportOptions.find((r: IReportOption): boolean => r.id === 'trend'),
};

/**
 * @description observes dashboard settings
 */
export const selectedReportSettingProvider =
  (): Observable<IReportSettings> => {
    return authenticatedUserProvider().pipe(
      switchMap((user: IUser): Observable<IReportSettings> => {
        return docData<IReportSettings>(
          doc(
            user.services.firestore,
            `userProfiles/${user.id}/settings/report`
          ) as DocumentReference<IReportSettings>
        ).pipe(
          map((settings: IReportSettings): IReportSettings => {
            return { ...defaultSettings, ...settings };
          })
        );
      })
    );
  };
